import { el, setAttr } from 'https://cdn.venturz.co/lib/redom.es.js';

import {
  applyTraits
} from '/programs/utilities/language.js';

import { InputValueGetter, InputValueSetter } from '../traits/value-accessors.js';

class TextInputRenderer {

  constructor() {

    this.input = null;

    this.el = el('.form-editor-textarea-input-renderer', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = el('textarea', {});

    return this.input;

  }

  update(options, fieldRow) {

    const attributes = {
      required: options.required,
      placeholder: options.placeholder || '',
      name: fieldRow.label
    };

    if (typeof options.minLength === 'number') {
      attributes.minLength = options.minLength;
    }

    if (typeof options.maxLength === 'number') {
      attributes.maxLength = options.maxLength;
    }

    setAttr(this.input, attributes);

  }

}

export default applyTraits(TextInputRenderer, [InputValueGetter, InputValueSetter]);